<div *ngIf="!isViewResult">
  <label class="item">{{idx+1}}. {{ question.content }}</label>
  <div *ngFor="let checkbox of question.options" class="form-check">
    <input class="form-check-input"
           type="checkbox"
           [checked]="optionCheckbox.indexOf(checkbox.id) != -1"
           [disabled]="statistic"
           (change)="getOptionCheckbox(checkbox.id)">
    <label class="form-check-label">
      {{checkbox.content}}        ({{checkbox.count}})
    </label>
  </div>
  <div class="form-inline">
    <span>{{'controlPanel.criteria.checkSeveralBoxes' | translate}}</span>
    <input type="number"
           class="form-control mx-2"
           name="optionCheckbox"
           [min]="0"
           [max]="question.options.length"
           [disabled]="statistic"
           [(ngModel)]="numberCheckbox">
    <span>{{'controlPanel.criteria.note' | translate}}</span>
  </div>
  <p class="mt-2"><span>{{numberApp || numberApp == 0 ? numberApp : totalApp}}</span> {{'controlPanel.criteria.applicants' | translate}}</p>
  <div class="form-inline" *ngIf="!statistic">
    <span>{{'controlPanel.criteria.assign' | translate}}</span>
    <input type="number"
           name="score"
           class="form-control mx-2"
           min="0"
           max="99"
           [disabled]="statistic"
           [(ngModel)]="score">
  </div>
  <div style="margin-top: 10px;">
    <button class="btn btn-success" *ngIf="!statistic" (click)="onGetAllResult()">{{'common.update' | translate}}</button>
  </div>
</div>
<div *ngIf="isViewResult">
  <label class="item">{{idx+1}}. {{ question.content }}</label>
  <table class="table table-bordered">
    <thead>
    <tr>
      <th scope="col"><b>{{ 'controlPanel.checkboxQuestion.answer' | translate }}</b></th>
      <th scope="col"><b>{{ 'controlPanel.checkboxQuestion.numOfApplicantsChecking' | translate }}	</b></th>
      <th scope="col"><b>{{ 'controlPanel.checkboxQuestion.answerSelected' | translate }}</b></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let checkbox of question.options">
      <td>{{checkbox.content}}</td>
      <td>{{checkbox.count}}</td>
      <td>{{optionCheckbox.indexOf(checkbox.id) != -1 ? 'Yes': 'No'}}</td>
    </tr>
    </tbody>
  </table>
  <p [innerHTML]="'controlPanel.checkboxQuestion.applicantsCheckAnswer' | translate : {numberCheckbox: numberCheckbox}"></p>
  <p><span>{{applicantsFulfill}}</span> {{'controlPanel.applicantFulfilled' | translate }} <b>{{score}}</b></p>
</div>
<hr>
